// Describes what a campaign's emails do from its settings, so the Emails
// section and the incentive panel (in Signup Settings) tell the same story. Mirrors the
// backend: SubscribeEmail always sends the signup email; single opt-in adds
// the download button to it; double opt-in delivers the download after the
// confirm click, by redirect or by a follow-up email (incentive.Followup*).

// flow(campaign) -> { signupEmail, incentive, followup }
//   signupEmail: what the signup email is / must contain
//   incentive:   how the download reaches them (null without an incentive)
//   followup:    true when a follow-up download email is sent
export function signupFlow(campaign) {
  const c = campaign || {};
  const doubleOptIn = !!c.double_opt_in;
  const hasIncentive = !!c.include_incentive;
  const byEmail = doubleOptIn && c.incentive_delivery === "email";
  const onPage = doubleOptIn && c.incentive_delivery === "page";

  if (!doubleOptIn) {
    return {
      signupEmail: hasIncentive
        ? "Sent as soon as they sign up. The reward button (download or link) is added automatically below your text."
        : "Sent as soon as they sign up (a welcome email).",
      incentive: hasIncentive
        ? "Delivered in the signup email: its button is added below your text automatically."
        : null,
      followup: false,
    };
  }
  return {
    signupEmail:
      "Sent as soon as they sign up, asking them to confirm. Add the Confirm button (Campaign blocks in the email editor); they're not subscribed until they click it." +
      (hasIncentive && byEmail ? " Once they confirm, they get the follow-up reward email (set up under Emails)." : "") +
      (hasIncentive && onPage ? " Clicking the confirm button shows “You're confirmed!”, then their reward opens." : "") +
      (hasIncentive && !byEmail && !onPage ? " Clicking the confirm button takes them straight to their reward." : ""),
    incentive: !hasIncentive
      ? null
      : byEmail
        ? "After they click the confirm button in the signup email, they get the follow-up email (under Emails), with the reward button."
        : onPage
          ? "After they click the confirm button in the signup email, they see “You're confirmed!” and their reward opens (with a button, in case it doesn't)."
          : "After they click the confirm button in the signup email, they're taken straight to their reward.",
    followup: hasIncentive && byEmail,
  };
}
